//
import store from '@/store/store'

/**
 * 
 */
export default class Service {

  /**
   * 
   */
  static getter(str) {
    return this.store().getters[str]
  }

  /**
   * 
   */
  static store() {
    return store
  }
}